const CONSENT_SOURCE_TYPES = {
  COOKIE: 'cookie',
  JS_API: 'jsApi',
  CALLBACK_JS_API: 'callbackJsApi',
  CMP: 'cmp',
};

export default CONSENT_SOURCE_TYPES;

export const isNonCookieConsentSource = type =>
  type === CONSENT_SOURCE_TYPES.JS_API ||
  type === CONSENT_SOURCE_TYPES.CALLBACK_JS_API ||
  type === CONSENT_SOURCE_TYPES.CMP;

export const DEFAULT_CONSENT_SOURCE_TYPE = CONSENT_SOURCE_TYPES.COOKIE;

export const COOKIE_ENCODINGS = {
  URL_ENCODED_KEY_VALUE: 'URLEncodedKeyValue',
  PLAIN_KEY_VALUE: 'PlainKeyValue',
};

export const DEFAULT_COOKIE_ENCODING = COOKIE_ENCODINGS.URL_ENCODED_KEY_VALUE;

// The builder-server hard-validates the legacy `privacy` block whenever it is
// present (getPrivacySettings throws on a falsy cookieName), so jsApi builds
// still send a placeholder cookie name. The consent module's jsApi source is
// what actually drives consent decisions in the built bundle.
export const JS_API_PRIVACY_COOKIE_NAME = 'OptanonConsent';

export const DEFAULT_OPT_IN_VALUES = '1, true';
